import { BrowserRouter } from 'react-router-dom'
import { TooltipProvider } from '@/components/ui/tooltip'
import { Toaster } from '@/components/ui/sonner'
import AppRouter from './router'

/**
 * Application root.
 *
 * App-wide providers + the router live here; the actual routes are defined in
 * src/router.tsx (explicit <Routes> — add a <Route> there for every new page).
 *
 * Add global providers (Auth context, React Query, theme, etc.) by wrapping
 * <AppRouter /> below, e.g.:
 *   <AuthProvider><AppRouter /></AuthProvider>
 */
export default function App() {
  return (
    <TooltipProvider>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster />
    </TooltipProvider>
  )
}
